
    import './styles.scoped.css';
    export default {
  "block-body-scroll": "awsui_block-body-scroll_19d8l_11pzs_97",
  "mobile-bar": "awsui_mobile-bar_19d8l_11pzs_101",
  "mobile-bar-refresh": "awsui_mobile-bar-refresh_19d8l_11pzs_114",
  "mobile-bar-breadcrumbs": "awsui_mobile-bar-breadcrumbs_19d8l_11pzs_119",
  "mobile-toggle": "awsui_mobile-toggle_19d8l_11pzs_128",
  "mobile-toggle-refresh": "awsui_mobile-toggle-refresh_19d8l_11pzs_134"
};
  